import {
  TbApi,
  TbBuildingBank,
  TbCash,
  TbChartBar,
  TbChecklist,
  TbCoins,
  TbCreditCard,
  TbHome,
  TbReceipt,
  TbSettings,
  TbShield,
  TbShieldCheck,
  TbServer,
  TbUsers,
  TbUsersGroup,
  TbWallet,
  TbWorld,
} from "react-icons/tb";

export const BAAS_BASE_PATH = "/baas";
/** Create instance screen (list remains at `/baas`). */
export const BAAS_INSTANCE_CREATE_PATH = "/baas/instancia";
export const BAAS_INSTANCES_PATH = "/baas/instancias";
export const BAAS_API_PATH = "/baas/api";
/** Homologation wizard (HML checklist → Valut liberates Production). */
export const BAAS_HOMOLOGACAO_PATH = "/baas/homologacao";
export const BAAS_STABLES_WALLET_PATH = "/baas/carteira-stables";
export const BAAS_STABLES_DEPOSIT_PATH = `${BAAS_STABLES_WALLET_PATH}/depositar`;
export const BAAS_STABLES_BUY_PATH = `${BAAS_STABLES_WALLET_PATH}/comprar`;
export const BAAS_STABLES_SELL_PATH = `${BAAS_STABLES_WALLET_PATH}/vender`;
export const BAAS_STABLES_SWAP_PATH = `${BAAS_STABLES_WALLET_PATH}/swap`;
/** Saque — same withdraw flow as IB `/stables/sacar`. */
export const BAAS_STABLES_WITHDRAW_PATH = `${BAAS_STABLES_WALLET_PATH}/sacar`;
/** @deprecated Use BAAS_STABLES_WITHDRAW_PATH — kept as soft-redirect alias. */
export const BAAS_STABLES_TRANSFER_PATH = `${BAAS_STABLES_WALLET_PATH}/transferir`;
export const BAAS_STABLES_TRANSACTIONS_PATH = "/baas/stables";
export const BAAS_CROSSBORDER_PATH = "/baas/crossborder";

export const buildBaasStablesOperationPath = (operation, walletId = null) => {
  const paths = {
    deposit: BAAS_STABLES_DEPOSIT_PATH,
    buy: BAAS_STABLES_BUY_PATH,
    sell: BAAS_STABLES_SELL_PATH,
    swap: BAAS_STABLES_SWAP_PATH,
    withdraw: BAAS_STABLES_WITHDRAW_PATH,
    transfer: BAAS_STABLES_WITHDRAW_PATH,
  };
  const base = paths[operation] ?? BAAS_STABLES_WALLET_PATH;
  if (!walletId) return base;
  return `${base}?walletId=${encodeURIComponent(walletId)}`;
};

export const buildBaasStablesWalletDetailPath = (walletId) =>
  `${BAAS_STABLES_WALLET_PATH}/${walletId}`;

export const BAAS_ACCOUNTS_PATH = "/baas/contas";
export const BAAS_ACCOUNTS_CREATE_PATH = `${BAAS_ACCOUNTS_PATH}?create=1`;
/** Instance owner + pinned shells (infra / programa). */
export const BAAS_ROOT_PATH = "/baas/root";
export const BAAS_TRANSACTIONS_PATH = "/baas/transacoes";
/** Exit-rail virtuals (WALLET + OTC) — Contas virtuais. */
export const BAAS_VIRTUAL_ACCOUNTS_PATH = "/baas/contas-virtuais";
export const BAAS_VIRTUAL_ACCOUNTS_CREATE_PATH = `${BAAS_VIRTUAL_ACCOUNTS_PATH}?create=1`;
/** Unfinished products — routes stay (placeholder); nav stays hidden for all instances. */
export const BAAS_LIQUIDITY_PATH = "/baas/liquidez";
export const BAAS_REPORTS_PATH = "/baas/relatorios";
export const BAAS_PLD_PATH = "/baas/pld";
export const BAAS_PROVIDER_PATH = "/baas/provedor";

export const buildBaasVirtualAccountCreatePath = (entityId = null) => {
  if (!entityId) return BAAS_VIRTUAL_ACCOUNTS_CREATE_PATH;
  return `${BAAS_VIRTUAL_ACCOUNTS_PATH}?create=1&entityId=${encodeURIComponent(entityId)}`;
};

export const BAAS_CARTOES_PATH = "/baas/cartoes";
export const BAAS_CREDITO_PATH = "/baas/credito";
/** Anchor for Crédito block on Emissor home (joined scroll, no tabs). */
export const BAAS_CARTOES_CREDITO_HASH = "baas-credito";
/** Crédito lives on Emissor home — keep legacy `/baas/credito` and `?section=credito` as soft-redirects. */
export const BAAS_CARTOES_CREDITO_PATH = `${BAAS_CARTOES_PATH}#${BAAS_CARTOES_CREDITO_HASH}`;
export const BAAS_CARTOES_SETTLEMENT_PATH = `${BAAS_CARTOES_PATH}/liquidacao`;
export const BAAS_CARTOES_REBATE_PATH = `${BAAS_CARTOES_PATH}/rebate`;
export const BAAS_CARTOES_SETTINGS_PATH = `${BAAS_CARTOES_PATH}/configuracoes`;
/** Issuer accounts (IssuerAccount / issacct_). */
export const BAAS_CARTOES_ACCOUNTS_PATH = `${BAAS_CARTOES_PATH}/contas`;
export const BAAS_CARTOES_ACCOUNTS_CREATE_PATH = `${BAAS_CARTOES_ACCOUNTS_PATH}/nova`;

export const buildBaasCardAccountDetailPath = (issuerAccountId) =>
  `${BAAS_CARTOES_ACCOUNTS_PATH}/${encodeURIComponent(issuerAccountId)}`;

export const BAAS_STABLES_METRICS_PATH = `${BAAS_STABLES_WALLET_PATH}/metricas`;
export const BAAS_STABLES_CREATE_PATH = `${BAAS_STABLES_WALLET_PATH}?create=1`;

/** Legacy top-level paths — soft-redirect to contas list. */
export const BAAS_SALDO_PATH = "/baas/saldo";
export const BAAS_EXTRATO_PATH = "/baas/extrato";
export const BAAS_PIX_PATH = "/baas/pix";

/**
 * Account detail sub-routes under `/baas/contas/:accountId`.
 * Default surface is Extrato (empty segment). Legacy saldo/pix/extrato/metadata paths soft-redirect.
 */
export const BAAS_ACCOUNT_TAB_SEGMENTS = {
  extrato: "",
  limites: "limites",
  conta: "conta",
  acessos: "acessos",
  /** @deprecated Settings live on the Conta tab — redirects to conta. */
  configuracao: "configuracao",
  /** @deprecated Metadata / Configuração live on the Conta tab — redirects to conta. */
  metadata: "metadata",
  /** @deprecated Saldos live on the detail header — redirects to base. */
  saldo: "saldo",
  /** @deprecated Pix keys open via modal — redirects to `?pixKeys=1`. */
  pix: "pix",
  /** @deprecated Alias for extrato (default). */
  details: "",
};

export const buildBaasAccountCreatePath = (entityId = null) => {
  if (!entityId) return BAAS_ACCOUNTS_CREATE_PATH;
  return `${BAAS_ACCOUNTS_PATH}?create=1&entityId=${encodeURIComponent(entityId)}`;
};

export const buildBaasAccountDetailPath = (accountId, tab = "extrato") => {
  const base = `${BAAS_ACCOUNTS_PATH}/${accountId}`;
  const resolvedTab =
    tab === "metadata" || tab === "configuracao" ? "conta" : tab;
  const segment = BAAS_ACCOUNT_TAB_SEGMENTS[resolvedTab];
  if (!segment) return base;
  return `${base}/${segment}`;
};

export const buildBaasAccountSaldoPath = (accountId) =>
  buildBaasAccountDetailPath(accountId);

export const buildBaasAccountExtratoPath = (accountId) =>
  buildBaasAccountDetailPath(accountId, "extrato");

/** Rails for Contas → Limites display + config screen. */
export const BAAS_LIMIT_RAIL_TABS = [
  { id: "pix", labelKey: "baas.accounts.detail.limites.tabs.pix" },
  { id: "stables", labelKey: "baas.accounts.detail.limites.tabs.stables" },
  { id: "swift", labelKey: "baas.accounts.detail.limites.tabs.swift" },
  { id: "transfers", labelKey: "baas.accounts.detail.limites.tabs.transfers" },
];

export const BAAS_LIMIT_RAIL_IDS = BAAS_LIMIT_RAIL_TABS.map((tab) => tab.id);

/** Hide product-gated rails from Contas → Limites (empty rail is worse than hide). */
export const getVisibleBaasLimitRailTabs = ({
  canViewPix = true,
  canViewStables = true,
} = {}) =>
  BAAS_LIMIT_RAIL_TABS.filter((tab) => {
    if (tab.id === "pix") return canViewPix;
    if (tab.id === "stables") return canViewStables;
    return true;
  });

export const buildBaasAccountLimitesPath = (accountId, rail = null) => {
  const base = buildBaasAccountDetailPath(accountId, "limites");
  const safeRail =
    rail && BAAS_LIMIT_RAIL_IDS.includes(rail) ? rail : null;
  if (!safeRail) return base;
  return `${base}?rail=${encodeURIComponent(safeRail)}`;
};

/**
 * Full-page account limits configuration (by rail). Optional `rail`: pix | stables | swift | transfers.
 * Entry point: Contas → account detail → Limites → Configurar only (not product shortcuts).
 */
export const buildBaasAccountLimitesConfigPath = (accountId, rail = null) => {
  const base = `${buildBaasAccountDetailPath(accountId, "limites")}/configurar`;
  const safeRail =
    rail && BAAS_LIMIT_RAIL_IDS.includes(rail) ? rail : rail ? "pix" : null;
  if (!safeRail) return base;
  return `${base}?rail=${encodeURIComponent(safeRail)}`;
};

export const buildBaasAccountPixPath = (accountId) =>
  `${buildBaasAccountDetailPath(accountId)}?pixKeys=1`;

export const BAAS_NAV_ITEMS = [
  { path: "/baas/inicio", labelKey: "baas.nav.home", icon: TbHome, exact: true },
  { path: BAAS_CARTOES_PATH, labelKey: "baas.nav.cartoes", icon: TbCreditCard },
  { path: BAAS_STABLES_WALLET_PATH, labelKey: "baas.nav.stablesWallet", icon: TbCash },
  { path: "/baas/entidades", labelKey: "baas.nav.entities", icon: TbUsers },
  { path: BAAS_TRANSACTIONS_PATH, labelKey: "baas.nav.transactions", icon: TbReceipt },
  {
    path: BAAS_PLD_PATH,
    labelKey: "baas.nav.pld",
    icon: TbShieldCheck,
  },
  { path: BAAS_ACCOUNTS_PATH, labelKey: "baas.nav.accounts", icon: TbBuildingBank },
  { path: BAAS_ROOT_PATH, labelKey: "baas.nav.root", icon: TbShield },
  { path: BAAS_VIRTUAL_ACCOUNTS_PATH, labelKey: "baas.nav.virtualAccounts", icon: TbWallet },
  // Unfinished — keep path for bookmarks; `navHidden` removes from sidebar for everyone.
  { path: BAAS_CROSSBORDER_PATH, labelKey: "baas.nav.crossborder", icon: TbWorld, navHidden: true },
  { path: BAAS_LIQUIDITY_PATH, labelKey: "baas.nav.liquidity", icon: TbCoins, navHidden: true },
  { path: BAAS_REPORTS_PATH, labelKey: "baas.nav.reports", icon: TbChartBar, navHidden: true },
];

/** Org-level admin (instances home sidebar) — cross-instance users/groups.
 * Entity product gates + primary user CRUD for a tenant live under the selected instance
 * (`BAAS_INSTANCE_USERS_PATH`). Configurações / API also live in instance admin. */
export const BAAS_ORG_USERS_PATH = "/baas/usuarios";
export const BAAS_ORG_GROUPS_PATH = "/baas/grupos";
/** Users scoped to the selected instance (Administração). */
export const BAAS_INSTANCE_USERS_PATH = "/baas/instancia/usuarios";
/** Blank KYC onboard invite list. Opened from entity detail (Ver links), not Administração. */
export const BAAS_ONBOARD_PATH = "/baas/onboard";

export const BAAS_ORG_ADMIN_NAV_ITEMS = [
  { path: BAAS_ORG_USERS_PATH, labelKey: "baas.nav.usuarios", icon: TbUsers },
  { path: BAAS_ORG_GROUPS_PATH, labelKey: "baas.nav.grupos", icon: TbUsersGroup },
];

/** Inside an instance: Usuários, Homologação, API, Configurações. */
export const BAAS_INSTANCE_ADMIN_NAV_ITEMS = [
  {
    path: BAAS_INSTANCE_USERS_PATH,
    labelKey: "baas.nav.usuarios",
    icon: TbUsers,
    /** Operador is not read-only (has transactions.write) — gate on users.manage. */
    requireCapability: "users.manage",
  },
  {
    path: BAAS_HOMOLOGACAO_PATH,
    labelKey: "baas.nav.homologacao",
    icon: TbChecklist,
    /** Shown when pair still needs HML homolog / manual Prod liberate. */
    showWhenHomologNeeded: true,
  },
  { path: BAAS_API_PATH, labelKey: "baas.nav.api", icon: TbApi, requireCapability: "api.keys.manage" },
  {
    path: BAAS_PROVIDER_PATH,
    labelKey: "baas.nav.provider",
    icon: TbServer,
    valutAdminOnly: true,
    requireAllowGlobalAccess: true,
  },
  {
    path: "/baas/configuracoes",
    labelKey: "baas.nav.configuracoes",
    icon: TbSettings,
    requireCapability: "settings.write",
  },
];

/** @deprecated Prefer BAAS_ORG_ADMIN_NAV_ITEMS — kept for path checks. */
export const BAAS_ADMIN_NAV_ITEMS = BAAS_ORG_ADMIN_NAV_ITEMS;

/** Legacy admin routes merged into /baas/configuracoes. */
export const BAAS_LEGACY_ADMIN_PATHS = ["/baas/passkey", "/baas/notificacoes"];

/** Placeholder pages for unfinished / deep-link routes (nav hidden via `navHidden`). */
export const BAAS_PLACEHOLDER_ROUTES = [
  "/baas/carteiras",
  BAAS_CROSSBORDER_PATH,
  BAAS_LIQUIDITY_PATH,
  BAAS_REPORTS_PATH,
];

export const isBaasPath = (pathname = "") =>
  pathname === BAAS_BASE_PATH || pathname.startsWith(`${BAAS_BASE_PATH}/`);

export const isBaasAdminPath = (pathname = "") =>
  BAAS_ORG_ADMIN_NAV_ITEMS.some(
    (item) => pathname === item.path || pathname.startsWith(`${item.path}/`),
  ) ||
  BAAS_INSTANCE_ADMIN_NAV_ITEMS.some(
    (item) => pathname === item.path || pathname.startsWith(`${item.path}/`),
  ) ||
  BAAS_LEGACY_ADMIN_PATHS.some((path) => pathname === path) ||
  pathname === "/baas/configuracoes" ||
  pathname.startsWith("/baas/configuracoes/");

/** Org-level Usuários / Grupos (instances home sidebar) — not the instance-scoped users page. */
export const isBaasOrgUsersGroupsPath = (pathname = "") =>
  pathname === BAAS_ORG_USERS_PATH ||
  pathname.startsWith(`${BAAS_ORG_USERS_PATH}/`) ||
  pathname === BAAS_ORG_GROUPS_PATH ||
  pathname.startsWith(`${BAAS_ORG_GROUPS_PATH}/`);

export const isBaasInstanceUsersPath = (pathname = "") =>
  pathname === BAAS_INSTANCE_USERS_PATH ||
  pathname.startsWith(`${BAAS_INSTANCE_USERS_PATH}/`);

export const isBaasOnboardPath = (pathname = "") =>
  pathname === BAAS_ONBOARD_PATH || pathname.startsWith(`${BAAS_ONBOARD_PATH}/`);

/** Landing sidebar: instances home and org-level admin (cross-instance users/groups). */
export const shouldUseBaasInstancesSidebar = (pathname = "", selectedInstanceId = null) => {
  if (
    pathname === BAAS_BASE_PATH ||
    pathname === `${BAAS_BASE_PATH}/` ||
    pathname === BAAS_INSTANCE_CREATE_PATH ||
    pathname === BAAS_INSTANCES_PATH
  ) {
    return true;
  }

  // Org users/groups keep the landing sidebar; instance users use the console sidebar.
  if (isBaasOrgUsersGroupsPath(pathname)) {
    return true;
  }

  if (isBaasInstanceUsersPath(pathname)) {
    return !selectedInstanceId;
  }

  if (isBaasOnboardPath(pathname)) {
    return !selectedInstanceId;
  }

  if (isBaasAdminPath(pathname) && !selectedInstanceId) {
    return true;
  }

  return false;
};

export const isBaasInstancesPath = (pathname = "", selectedInstanceId = null) =>
  shouldUseBaasInstancesSidebar(pathname, selectedInstanceId);

export const isBaasConsolePath = (pathname = "", selectedInstanceId = null) =>
  isBaasPath(pathname) && !shouldUseBaasInstancesSidebar(pathname, selectedInstanceId);
